import { TOKEN_LOCAL_STORAGE_KEY } from '../const/app';
import { useSystemStore } from '../stores/SystemStore';

export const useSetUserToken = (): ((token?: string, skipLocalStorage?: boolean) => void) => {
	const setToken = useSystemStore(state => state.setToken);

	return (token?: string, skipLocalStorage = false) => {
		if (!skipLocalStorage) {
			if (!token) {
				localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY);
			} else {
				localStorage.setItem(TOKEN_LOCAL_STORAGE_KEY, token);
			}
		}

		setToken(token);
	};
};
